import Swiper from './Swiper';
import $ from 'swiper/src/utils/dom';
import { mergeSettings, writeNavigationButtons } from './Functions';

const type = {
    navigation(slider, settings, nummberOfSlides) {
        let $group = $(slider).parents('.swiper-group');
        let content = $group.find('.swiper-type--content')[0];
        let needButtons = nummberOfSlides > 1;
        let buttons = needButtons ? writeNavigationButtons({ slider }) : null;
        let active = '-active';
        let options = mergeSettings({
            typeSettings: {
                freeMode: true,
                slidesOffsetAfter: 0,
                slidesOffsetBefore: 0,
                slidesPerView: 'auto',
                navigation: {
                    nextEl: needButtons ? buttons.next : null,
                    prevEl: needButtons ? buttons.prev : null,
                },
                mousewheel: {
                    enabled: true,
                    forceToAxis: true,
                },
            },
            settings,
            nummberOfSlides,
        });

        new Swiper(slider, options);

        $(slider.swiper.slides[0]).addClass('-active');
        $(slider).on('click', '.swiper-slide', function (event) {
            event.preventDefault();
            $(slider.swiper.slides).removeClass(active);
            $(this).addClass(active);
            let index = $(this).index();
            if (content && content.swiper) {
                // This is commented out because it didn't work correctly and isn't necessary anyways
                //slider.swiper.slideTo(index ? index - 1 : 0);
                content.swiper.slideTo(index);
            }
        });
    },
    content(slider, settings, nummberOfSlides) {
        let options = mergeSettings({
            typeSettings: {
                simulateTouch: false,
                allowTouchMove: false,
                autoHeight: true,
                effect: 'fade',
            },
            settings,
            nummberOfSlides,
        });

        new Swiper(slider, options);
    },
};

export default type;
